<template>
  <div>
    <common-header title="본인인증" :showTitle="true" :showLeftMenu="false" :showClose="true" v-on:onClose="onClose"/>
    <main>
    <iframe name="identityFrame" style="margin-top:15.92526vw;width:100%;height:100%;position: absolute;display: block;top: 0;left: 0;">
      <form name="identityForm" method="post" ref="form" target="identityFrame">
        <input type="hidden" name="addVar" :value="kind">	           
      </form>
    </iframe>
    </main>
  </div>
</template>

<script>
import {AppConfig} from '@/config/AppConfig';
import { Axios } from '@/api/Axios';
export default {
  props:['isModal', 'kind'],
  mounted() {
    // this.$refs.form.action = AppConfig.VUE_APP_CERTIFICATE.URL;   
    this.$refs.form.action = AppConfig.VUE_APP_CERTIFICATE.URL; //"https://dev-gongcha.easymembership.co.kr/pcc/pcc_request.jsp" 
    this.$refs.form.submit();
  },
  beforeMount(){

    if(window.addEventListener) {
      console.log(`IdentityVerification.beforeMount -> addEventListener`);
      window.addEventListener("message", this.onPccResult, false);       
    }else if (window.attachEvent) {
      console.log(`IdentityVerification.beforeMount -> attachEvent`);
      window.attachEvent("onPccResult", this.onPccResult, false);
    }
  },
  methods:{
    onClose(e){
      console.log('onClose ' + e);
      if(this.isModal){
        this.$modal.hide("IdentityVerification")
        this.$modal.hideAll();

        if(window.removeEventListener) {
          window.removeEventListener('message', this.onPccResult, false);
        } else if (window.attachEvent) {
          window.detachEvent('onPccResult', this.onPccResult);
        }

        return;
      }

      this.$router.go(-1)
    },
    onPccResult(event){
      console.log(`IdentityVerification.methods.onPccResult -> event : ${JSON.stringify(event)}, data : ${JSON.stringify(event.data)}`);

      var data = event.data;  

      if(data && data.func && data.message && data.func == 'onPccResult') {
        //호출한 페이지로 결과 이벤트 전송
        console.log('to onVerificationResult');

        setTimeout(() => {
          this.onClose()
          this.$emit('onVerificationResult', data);
        }, 1500);
      }
      // if(this.isModal){
      //   this.$modal.hide("IdentityVerification")        
      //   return;
      // }
    }
  }
}
</script>
<style scoped>
iframe 
{
 display: block; 
 width: 100%; 
 border: none; 
 overflow-y: auto; 
 overflow-x: hidden;
}
div {
    height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/components/common/IdentityVerification.vue